<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M4.5 1.00006C2.84315 1.00006 1.5 2.34321 1.5 4.00006V15.7435L8.0653 8.65645L8.60439 8.07452L9.19086 8.60868L11.4268 10.6452L15.118 6.47023L15.7156 5.79432L16.3152 6.46849L24.5 15.6719V4.00006C24.5 2.34321 23.1569 1.00006 21.5 1.00006H4.5ZM24.5 18.0795L15.7191 8.20593L12.6099 11.7227L14.0578 13.0415L15.6918 11.3878L16.2916 10.7808L16.8587 11.4185L21.75 16.9185L22.9342 18.2501H21.1522H6.47826H4.70312L5.87892 16.9202L10.3669 11.844L8.69995 10.3257L1.5 18.0978V21.0001C1.5 22.6569 2.84315 24.0001 4.5 24.0001H21.5C23.1569 24.0001 24.5 22.6569 24.5 21.0001V18.0795ZM8.2534 16.6501L11.55 12.9215L13.5483 14.7416L14.1161 15.2588L14.656 14.7124L16.2301 13.1194L19.3701 16.6501H8.2534Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgAFPMLiveEvent',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>